import { Anchor, Details } from 'components/atoms';
import React, { memo } from 'react';
import { PatentRM } from 'types';
import { useTranslation } from 'utils/hooks';
import { TranslationKey } from 'utils/hooks/useTranslation';

import css from './Patent.module.scss';

interface PatentProps
{
  patent: PatentRM;
}

const Patent: React.FC<PatentProps> = (props) =>
{
  const { patent } = props;
  const { t } = useTranslation(['profiles', 'formats']);

  const erfinder = [...patent.erfinder].map(
    (e) => `${e.name} ${e.ort && e.land ? `(${e.ort}, ${e.land})` : ''}`.trim(),
  );

  const rows: [string, any][] = [
    ['deletionActualDate', patent.löschWirkDatum ? t('formats:date', { value: patent.löschWirkDatum }) : null],
    ['deletionDate', patent.löschEintragungDatum ? t('formats:date', { value: patent.löschEintragungDatum }) : null],
    ['registerNumber', patent.anmeldeNummer],
    ['eNumber', patent.eNummer],
    ['ipc', patent.ipc1],
    ['moreIpcs', patent.ipcs.join('\n')],
    ['language', patent.sprache],
    ['inventors', erfinder.join('\n')],
  ];

  function renderRowIfValue(localizationKey: string, value: any)
  {
    if (value !== undefined && value !== null && value !== '')
    {
      return (
        <tr key={`${patent.id}_row_${localizationKey}`}>
          <th>{t(`profiles:unternehmen.patente.${localizationKey}` as TranslationKey)}</th>
          <td>{value}</td>
        </tr>
      );
    }
    return null;
  }

  return (
    <li className={css.container}>

      <h4 className={css.title}>{patent.titel}</h4>

      {/* Initially visible content */}
      <table className={css.table}>
        <tbody>
          { renderRowIfValue('type', patent.art) }
          { renderRowIfValue('status', patent.status) }
          { renderRowIfValue('registerDate', patent.anmeldeDatum ? t('formats:date', { value: patent.anmeldeDatum }) : null) }
          { renderRowIfValue('grantDate', patent.erteilPublDatum ? t('formats:date', { value: patent.erteilPublDatum }) : null) }
        </tbody>
      </table>

      {/* Expandable details */}
      <Details>
        <table className={css.table}>
          <tbody>

            { rows.map((row) => renderRowIfValue(row[0], row[1])) }

            {
              patent.veröffentlichungen.length > 0 && (
                <tr>
                  <th>{t('profiles:unternehmen.patente.publications')}</th>
                  <td>
                    {[...patent.veröffentlichungen].map((v) => (
                      <div key={v.veröffentlichungsNummer + v.veröffentlichungsArt}>

                        {patent.art === 'Europäisch' && (
                          <>
                            {`${v.ausgabedatum ? t('formats:date', { value: v.ausgabedatum }) : ''} ${v.veröffentlichungsArt}`.trim()}
                          </>
                        )}

                        {patent.art === 'National' && (
                          <Anchor
                            target="_blank"
                            href={`http://seeip.patentamt.at/Publication/Details?PublicationNumber=${v.veröffentlichungsNummer}`}
                          >
                            {`${v.ausgabedatum ? t('formats:date', { value: v.ausgabedatum }) : ''} ${v.veröffentlichungsArt} ${v.veröffentlichungsNummer}`.trim()}
                          </Anchor>
                        )}

                      </div>
                    ))}
                  </td>
                </tr>
              )
            }

          </tbody>
        </table>
      </Details>

    </li>
  );
};

export default memo(Patent);
